import script from "./image.vue?vue&type=script&setup=true&lang=js"
export * from "./image.vue?vue&type=script&setup=true&lang=js"

import "./image.vue?vue&type=style&index=0&id=55b8a8ca&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b8a8ca"]])

export default __exports__